import { EU_STRIPE_PRICE_ID, STRIPE_PRICE_ID } from "../constants/formConstants";

const EU_CAMPAIGN_MARKER = "_EU_";

export const CANONICAL_PAYWALL_ROUTES = [
  "/colortype-3month-29",
  "/colortype-3month-29-upsell",
  "/colortype-3month-29-upsell-v2",
  "/colortype-1month-29",
  "/glasses-3month-29-upsell-v2",
  "/sunglasses-3month-29-upsell-v2",
  "/makeup-3month-29-upsell-v2",
  "/haircolor-3month-29",
  "/haircolor-recomend-3month-29",
  "/hairstyle-3month-29-woman",
  "/bodytype-3month-29-woman",
  "/wedding-guest-3month-29-woman",
  "/hairstyle-3month-29-man",
  "/faceshape-3month-29",
  "/faceshape_3month_29",
];

const USD_TRIAL_PRICING = {
  offerId: "trial-usd-v1",
  isEuPricing: false,
  trialCost: "0.99",
  trialDisplay: "$1",
  trialValue: 0.99,
  trialValueText: "$0.99",
  trialOriginalDisplay: "$6.99",
  amount: 99,
  currency: "usd",
  purchaseValue: 0.99,
  priceId: STRIPE_PRICE_ID,
  subscriptionDisclaimerPrice: "29.99$",
};

const EUR_TRIAL_PRICING = {
  offerId: "trial-eur-v1",
  isEuPricing: true,
  trialCost: "1",
  trialDisplay: "€1",
  trialValue: 1,
  trialValueText: "€1",
  trialOriginalDisplay: "€6.99",
  amount: 100,
  currency: "eur",
  purchaseValue: 1,
  priceId: EU_STRIPE_PRICE_ID,
  subscriptionDisclaimerPrice: "29.90€",
};

const HAIRSTYLE_ONETIME_PRICING = {
  ...USD_TRIAL_PRICING,
  offerId: "hairstyle-onetime-usd-v1",
  trialCost: "2.99",
  trialDisplay: "$2.99",
  trialOriginalDisplay: "$9.99",
  trialValue: 2.99,
  trialValueText: "$2.99",
  amount: 299,
  purchaseValue: 2.99,
};

const HAIRSTYLE_ONETIME_EUR_PRICING = {
  ...HAIRSTYLE_ONETIME_PRICING,
  offerId: "hairstyle-onetime-eur-v1",
  isEuPricing: true,
  trialDisplay: "€2.99",
  trialOriginalDisplay: "€9.99",
  trialValueText: "€2.99",
  currency: "eur",
  priceId: EU_STRIPE_PRICE_ID,
};

const LEGACY_TRIAL_ROUTES = ["/v1", "/month", "/hair", "/hairstyle", "/hairstyle-man", "/v1_3months_upsell"];
const normalizeRoute = (pathname) => pathname.toLowerCase().replace(/\/+$/, "");

export const isCanonicalPaywallRoute = (pathname = "") =>
  CANONICAL_PAYWALL_ROUTES.includes(pathname);

export const hasEuCampaignMarker = (search = "") => {
  const params = new URLSearchParams(search || "");
  return params.getAll("utm_campaign").some((value) => value.includes(EU_CAMPAIGN_MARKER));
};

export const getPaywallPricingContext = (pathname = "", search = "") => {
  if (normalizeRoute(pathname) === "/hairstyle-onetime-woman") {
    return hasEuCampaignMarker(search) ? HAIRSTYLE_ONETIME_EUR_PRICING : HAIRSTYLE_ONETIME_PRICING;
  }
  if (isCanonicalPaywallRoute(pathname) && hasEuCampaignMarker(search)) {
    return EUR_TRIAL_PRICING;
  }

  return USD_TRIAL_PRICING;
};

export const getPaymentOfferId = (pathname, search, amount, currency) => {
  const route = normalizeRoute(pathname);
  const supported = route === "/hairstyle-onetime-woman" ||
    CANONICAL_PAYWALL_ROUTES.includes(route) || LEGACY_TRIAL_ROUTES.includes(route);
  if (!supported) return undefined;
  const pricing = getPaywallPricingContext(pathname, search);
  // Never relabel an unsupported or inconsistent amount as the cheap trial.
  return amount === pricing.amount && currency === pricing.currency ? pricing.offerId : undefined;
};
